import {NgModule, Pipe, PipeTransform} from '@angular/core';


@Pipe({
    name: 'highlightTerms',
    standalone: false
})
export class HighlightTermsPipe implements PipeTransform {

    transform(value: any, args: any): any {
        if (!args) {return value;}
		[].concat(args).forEach(term => {
			var re = new RegExp(term['name'], 'gi');
			value = value.replace(re, `<a href='${term['link']}' class='bg-highlight'>$&</a>`);
        })
        return value;
    }
}

@NgModule({
    declarations: [HighlightTermsPipe],
    exports: [HighlightTermsPipe]
})
export class HighlightTermsPipeModule {}